/* unplugin-vue-components disabled */import script from "./memberTag.vue?vue&type=script&setup=true&name=Medal&lang=js"
export * from "./memberTag.vue?vue&type=script&setup=true&name=Medal&lang=js"

import "./memberTag.vue?vue&type=style&index=0&id=b1eb756a&lang=scss&scoped=true"

import exportComponent from "E:\\new-admin\\3.0\\ruoyi-vue3-cli\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b1eb756a"]])

export default __exports__